// extracted by mini-css-extract-plugin
export default {"present":"Prize_present__is+on","prize":"Prize_prize__RAaFM","bigPresent":"Prize_bigPresent__u0SL7"};